import clsx from "clsx";
import { ComponentProps, FunctionComponent } from "react";

import VergePrimaryNavigationMobile from "@ui/components/brand/theverge/VergePrimaryNavigationMobile";
import VergeStandardNavigation from "@ui/components/brand/theverge/VergeStandardNavigation";
import PrimaryNavigation from "@ui/components/navigation/Navigation/components/PrimaryNavigation";
import { VergeNavigationVariants } from "@ui/components/navigation/Navigation/Navigation";

import * as styles from "./VergePrimaryNavigation.css";

type Props = ComponentProps<typeof PrimaryNavigation>;

const VergePrimaryNavigation: FunctionComponent<Props> = (props) => {
  const { items, variant, PrimaryLogo, Logo, showSubscribeInNav } = props;

  return (
    <div
      className={clsx(
        styles.container,
        styles.background[variant as keyof typeof styles.background],
      )}
      // Concert ads (loaded `beforeInteractive`) injects DOM into the nav before
      // hydration completes, causing a hydration mismatch React would otherwise
      // log loudly in dev. React 18 silently recovers in prod by re-rendering
      // the mismatched subtree on the client.
      suppressHydrationWarning
    >
      <div className={styles.desktop} suppressHydrationWarning>
        <VergeStandardNavigation
          Logo={PrimaryLogo || Logo}
          items={items}
          variant={variant as VergeNavigationVariants}
          hideLogo={variant === "homepage"}
          showSubscribeInNav={showSubscribeInNav}
        />
      </div>
      <div className={styles.mobile} suppressHydrationWarning>
        <VergePrimaryNavigationMobile
          Logo={PrimaryLogo || Logo}
          variant={variant as VergeNavigationVariants}
          hideLogo={variant === "homepage"}
        />
      </div>
    </div>
  );
};

export default VergePrimaryNavigation;
